import { ArrowButton } from "@/components/mypage/arrowButton";
import { useAuthStore } from "@roman/shared/store/auth.store";
import type { PointWithdrawalType } from "@roman/shared/types/PointWithdrawal";
import { pointsToYen } from "@roman/shared/utils/pointsToYen";
import type React from "react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CardComponent } from "./Card";

interface WithDrawalPageProps {
  onClick: ({
    selectedMethod,
  }: {
    selectedMethod: PointWithdrawalType;
  }) => void;
}

export type CardContent = {
  id: PointWithdrawalType;
  heading: string;
  footer: string;
  src: string;
  imageSize: { width: string; height: string };
  limit: { lte: string; ste: string };
};

// const cardContents: CardContent[] = [
//   {
//     id: "Amazon",
//     heading: "Amazonギフトカード",
//     src: "/assets/amazon-gift.svg",
//     imageSize: { width: "90", height: "90" },
//     limit: { lte: "500", ste: "100,000" },
//   },
//   {
//     id: "Apple",
//     heading: "Apple Gift Card",
//     src: "/assets/apple-gift.svg",
//     imageSize: { width: "72", height: "72" },
//     limit: { lte: "1000", ste: "100,000" },
//   },
//   {
//     id: "Google",
//     heading: "Google Playギフトコード",
//     src: "/assets/google-gift.svg",
//     imageSize: { width: "51", height: "57" },
//     limit: { lte: "500", ste: "100,000" },
//   },
// ];

const pointCardContents: CardContent[] = [
  {
    id: "AuPay",
    heading: "えらべるPay",
    footer: "えらべるPay",
    src: "/assets/aupay.png",
    imageSize: { width: "180", height: "123" },
    limit: { lte: "500", ste: "100,000" },
  },
  {
    id: "Giftee",
    heading: "giftee Box Select",
    footer: "giftee Box Select",
    src: "/assets/giftee.png",
    imageSize: { width: "180", height: "175" },
    limit: { lte: "500", ste: "100,000" },
  },
];

export const WithDrawalPage: React.FC<WithDrawalPageProps> = ({ onClick }) => {
  const navigate = useNavigate();
  const user = useAuthStore((state) => state.user);
  const [point, setPoint] = useState<string>("");

  useEffect(() => {
    if (user) {
      setPoint(user.redeemablePoints);
    }
  }, [user]);

  return (
    <div className="bg-white min-w-full min-h-screen">
      <div className="p-[18px] flex flex-col items-start gap-10">
        <div className="flex flex-col items-start gap-3 w-full">
          <div className="flex items-center gap-3">
            <p className="text-xl font-bold -tracking-[.01em] text-black">所持報酬</p>
            {/* <InstructionButton onClick={handleInstructionPointExchange} /> */}
          </div>

          <div className="flex flex-col items-start gap-2 w-full">
            <div
              className="flex items-center justify-between p-4 w-full border border-disabled border-solid rounded-md cursor-pointer"
              onClick={() => navigate("/record")}
            >
              <div className="flex flex-col items-start gap-1.5">
                <p className="text-xs font-bold -tracking-[.01em]">残高</p>
                <p className="text-primary text-xl font-medium -tracking-[.01em]">
                  <span className="text-[32px] font-bold mr-2">{pointsToYen(point)}</span>円
                </p>
                <p className="text-gray text-xs font-bold -tracking-[.01em]">
                  {Number(point).toLocaleString("en-US")}無料ポイント相当
                </p>
              </div>
              <ArrowButton className="rotate-90" />
            </div>
          </div>
        </div>

        {/* Uncomment the following section if you want to display these gift cards */}
        {/* <div className="flex flex-col items-start gap-3">
          <div className="flex items-center">
            <p className="text-xl font-bold -tracking-[.01em] text-black">おすすめのギフト券</p>
          </div>

          <div className="sm:flex grid grid-cols-2 items-start gap-3 w-full">
            {cardContents.map((cardContent) => {
              return (
                <div className="flex justify-center">
                  <CardComponent
                    key={cardContent.id}
                    onClick={() => onClick({ selectedMethod: cardContent.id })}
                    cardContent={cardContent}
                  />
                </div>
              );
            })}
          </div>
        </div> */}

        <div className="flex flex-col items-start gap-3">
          <div className="flex items-center">
            <p className="text-xl font-bold text-black">選べるギフト券</p>
          </div>

          <div className="flex items-start gap-3 w-full">
            {pointCardContents.map((content) => (
              <div key={content.id} className="flex flex-col items-center">
                <p className="text-sm font-bold text-dark-gray -tracking-[.01em] mb-1 w-full">{content.heading}</p>
                <CardComponent onClick={() => onClick({ selectedMethod: content.id })} cardContent={content} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
